/*
 * @Author: dongwenjuan@hikvison.com.cn
 * @Date: 2022-01-05 20:11:13
 * @LastEditors: dongwenjuan@hikvison.com.cn
 * @LastEditTime: 2022-02-15 15:05:26
 */
import * as React from 'react';
import Empty from '../empty';
import { ConfigConsumer } from '.';
var renderEmpty = function renderEmpty(componentName) {
  return /*#__PURE__*/React.createElement(ConfigConsumer, null, function (_ref) {
    var getPrefixCls = _ref.getPrefixCls;
    var prefix = getPrefixCls('empty');
    switch (componentName) {
      case 'Table':
      case 'List':
        return /*#__PURE__*/React.createElement(Empty, {
          image: Empty.PRESENTED_IMAGE_SIMPLE
        });
      case 'Select':
      case 'TreeSelect':
        return /*#__PURE__*/React.createElement("div", {
          className: "".concat(prefix, "-select")
        }, "\u6682\u65E0\u6570\u636E");
      case 'Cascader':
      case 'Transfer':
      case 'Mentions':
        return /*#__PURE__*/React.createElement(Empty, {
          image: Empty.PRESENTED_IMAGE_SIMPLE,
          className: "".concat(prefix, "-small")
        });
      default:
        return /*#__PURE__*/React.createElement(Empty, null);
    }
  });
};
export default renderEmpty;